export const productHasTecSelect = (prices: { tecSelect?: number } | null | undefined) => {
  return typeof prices?.tecSelect === 'number' && prices?.tecSelect > 0
}
